<script setup lang="ts">
import { useTranslations } from '@/shared/composables/useTranslations';

import Badge from './Badge.vue';

type BadgeSize = 'sm' | 'md' | 'lg';

withDefaults(
  defineProps<{
    size?: BadgeSize;
    position?: 'overlay' | 'inline';
    showIcon?: boolean;
  }>(),
  {
    size: 'sm',
    position: 'overlay',
    showIcon: false
  }
);

const { t } = useTranslations();
</script>

<template>
  <Badge
    :size="size"
    :position="position"
    variant="bg-white border border-gray-300 text-gray-800 shadow-sm"
    class="whitespace-nowrap"
  >
    <!-- Gift icon (matches liquid icon-gift.liquid) -->
    <svg
      v-if="showIcon"
      class="mr-1 size-[1.4em]"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
    >
      <g fill="currentColor">
        <path
          fill-rule="evenodd"
          d="M14 6a2.5 2.5 0 0 0-4-3a2.5 2.5 0 0 0-4 3H3.25C2.56 6 2 6.56 2 7.25v.5C2 8.44 2.56 9 3.25 9h6V6h1.5v3h6C17.44 9 18 8.44 18 7.75v-.5C18 6.56 17.44 6 16.75 6H14Zm-1-1.5a1 1 0 0 1-1 1h-1v-1a1 1 0 1 1 2 0Zm-6 0a1 1 0 0 0 1 1h1v-1a1 1 0 0 0-2 0Z"
          clip-rule="evenodd"
        ></path>
        <path
          d="M9.25 10.5H3v4.75A2.75 2.75 0 0 0 5.75 18h3.5v-7.5Zm1.5 7.5v-7.5H17v4.75A2.75 2.75 0 0 1 14.25 18h-3.5Z"
        ></path>
      </g>
    </svg>
    <span class="capitalize">{{ t('patterns.products.pattern.free') }}</span>
  </Badge>
</template>
